export default {
  name: 'ValidationWatcher',
  props: ['valid'],
  watch: {
    valid: {
      immediate: true,
      handler() {
        this.$emit('change', this.valid);
      }
    }
  },
  render() {
    // nothing
  }
};
